import { getRoot, types, flow, Instance } from 'mobx-state-tree';

import * as AuthAPI from 'src/services/auth';
import { SimpleApiStore } from '@src/features/common';
import { ROUTES } from 'src/constants';
import { composeFullUrl } from 'src/helpers';

/*
  The main reason why AuthStore has been extracted from UserStore - 
  user can exists while not being authorized when he is applying to job through uploading CV
*/

export const AuthStore = types
  .compose(
    SimpleApiStore,
    types.model('AuthStore', {
      isAuthorized: types.optional(types.boolean, false)
    })
  )
  .actions(self => ({
    setIsAuthorized: function(value) {
      self.isAuthorized = value;
    },
    FRA_authorize: flow(function*() {
      const { userStore } = getRoot(self);
      yield userStore.fetchUser();
      self.isAuthorized = true;
    }),
    signIn: flow(function*(...args: Parameters<typeof AuthAPI.signIn>) {
      yield AuthAPI.signIn(...args);
      yield self.FRA_authorize();
    }),
    oauthSignIn: flow(function*(...args: Parameters<typeof AuthAPI.oauthSignIn>) {
      const { userStore } = getRoot(self);
      const response = yield AuthAPI.oauthSignIn(...args);
      userStore.setUserInfo(response.user);
      self.isAuthorized = true;
    }),
    checkEmail: function(payload) {
      return AuthAPI.checkEmail(payload);
    },
    logout: flow(function*() {
      try {
        const { userStore } = getRoot(self);
        yield AuthAPI.logout();
        userStore.setUserInfo(null);
        self.isAuthorized = false;
      } catch (error) {
      } finally {
        window.location.replace(composeFullUrl(ROUTES.home));
      }
    })
  }));

export type IAuthStore = Instance<typeof AuthStore>;
